import {ThemeOptions, menuItemClasses} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiMenu = ({autocomplete, focus}: Tokens): ThemeOptions['components'] => {
  return {
    MuiMenu: {
      styleOverrides: {
        root: {},
        list: {},
        paper: {}
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.menuButton-item': {
            '&:hover': {
              backgroundColor: autocomplete.desktop.unselected.hover.background.color,
              color: autocomplete.desktop.unselected.hover.font.color
            },
            '&.Mui-focusVisible': {
              backgroundColor: autocomplete.desktop.unselected.focus.background.color,
              color: autocomplete.desktop.unselected.focus.font.color,
              outline: `${focus.outline.width} ${focus.outline.style} ${focus.outline.color}`,
              outlineOffset: '-2px'
            },
            [`&.${menuItemClasses.selected}`]: {
              backgroundColor: autocomplete.desktop.selected.background.color,
              color: autocomplete.desktop.selected.font.color,
              '&:hover': {
                backgroundColor: autocomplete.desktop.selected.background.color,
                color: autocomplete.desktop.selected.font.color
              },
              '&.Mui-focusVisible': {
                backgroundColor: autocomplete.desktop.selected.focus.background.color,
                color: autocomplete.desktop.selected.focus.font.color,
                outline: `${focus.outline.width} ${focus.outline.style} ${focus.outline.color}`,
                outlineOffset: '-2px'
              }
            }
          }
        }
      }
    }
  };
};
